import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "BalSheetLiqRatio" })((_theme) => ({
  page: {
    margin: "20px",
  },
  balSheetLiqRatioExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
